import { render, staticRenderFns } from "./male.vue?vue&type=template&id=839e18dc&scoped=true"
import script from "./male.vue?vue&type=script&lang=js"
export * from "./male.vue?vue&type=script&lang=js"
import style0 from "./male.vue?vue&type=style&index=0&id=839e18dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839e18dc",
  null
  
)

export default component.exports